<template>
  <div>

    <v-alert
      prominent
      type="warning"
      icon="mdi-map-marker-question-outline"
      v-if="isAdmin"
    >
      <v-row align="center">
        <v-col class="grow">
          {{ $t("forms.info.warningDirectEdit") }}
        </v-col>
        <v-col class="shrink">
          <v-btn
            to="/manage/edit/stays"
          >
            <v-icon
              left
              dark
            >
              mdi-arrow-right-circle
            </v-icon>
            {{ $t("forms.info.gotoDirectEdit") }}
          </v-btn>
        </v-col>
      </v-row>
    </v-alert>

    <PendingUserForms
      v-if="pendingForms.length"
      :title="$t('table.stays.pendingForms')"
      :items="pendingForms"
    />

    <v-card class="mt-4">
      <v-card-title>{{ $t("forms.title") }}</v-card-title>
      <v-card-text>
        <v-list>
          <v-list-item-group>
            <v-row no-gutters>
              <v-col
                v-for="(form, index) in forms"
                :key="index"
                cols="12"
                md="6"
                lg="4"
                class="text-left"
              >
                <v-list-item :to="form.path">
                  <v-list-item-icon>
                    <v-icon v-text="form.icon"></v-icon>
                  </v-list-item-icon>
                  {{ $t(form.title) }}
                </v-list-item>
              </v-col>
            </v-row>
          </v-list-item-group>
        </v-list>
      </v-card-text>
    </v-card>

    <v-data-table
      :headers="headers"
      :items="stays"
      :search="search"
      class="elevation-1 table-cursor-hand mt-4"
      :items-per-page="15"
      :footer-props="{
        itemsPerPageOptions: [15, 30, -1],
        itemsPerPageText: $t('table.itemsPerPageText')
      }"
      sort-by="date"
      sort-desc
      @click:row="clickRow"
      :loading="loading"
      :loading-text="$t('table.loading')"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            :label="$t('search')"
            single-line
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
        </v-toolbar>
      </template>
      <template v-slot:item.person="{ item }">
        {{ personFullName(item) }}
      </template>
      <template v-slot:item.organization="{ item }">
        {{ organizationName(item) }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import axios from "axios";
import PendingUserForms from "../forms/PendingUserForms";
export default {
  components: { PendingUserForms },
  data: () => ({
    pendingForms: [{}],
    loading: true,
    search: "",
    stays: [],
    people: [],
    organizations: [],
    forms: [
      {
        icon: "mdi-plus",
        title: "stay.forms.newStay",
        path: "/my-forms/stay/newStay"
      }
    ]
  }),

  computed: {
    headers() {
      return [
      {
          text: this.$t("table.person"),
          value: "person",
        },
        {
          text: this.$t("table.organization"),
          value: "organization",
        },
        {
          text: this.$t("table.start_date"),
          value: "start_date"
        },
        {
          text: this.$t("table.end_date"),
          value: "end_date"
        },
      ];
    }
  },

  created() {
    this.initialize();
  },

  methods: {
    personFullName(item) {
      const person = this.people.find(person => person.id === item.person);
      return person ? `${person.preferred_name.given_name} ${person.preferred_name.family_name}` : "-";
    },
    organizationName(item) {
      if (!item || item.organization === null || item.organization === undefined) {
        return "-";
      }
      if (typeof item.organization === "string" && item.organization.trim() !== "") {
        return item.organization;
      }
      if (typeof item.organization === "object") {
        if (item.organization.name) {
          return item.organization.name;
        }
        if (item.organization.title) {
          return item.organization.title;
        }
        const organizationId = item.organization.id;
        const organization = this.organizations.find(org => org.id === organizationId);
        return organization ? organization.name : "-";
      }
      const organization = this.organizations.find(organization => organization.id === item.organization);
      return organization ? organization.name : "-";
    },
    initialize() {
      let path = this.$store.state.endpoint + "/user/stay";
      axios
        .get(path)
        .then(response => {
          let path = this.$store.state.endpoint + "/personName";
          axios
            .get(path)
            .then(response => {
              this.people = response.data;
            })
            .catch(error => {
              console.log(error);
            });
          path = this.$store.state.endpoint + "/organization";
          axios
            .get(path)
            .then(response => {
              this.organizations = response.data;
            })
            .catch(error => {
              console.log(error);
            });
          this.stays = response.data;
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });

      path =
        this.$store.state.endpoint + "/user/moderatedOperations/pending/stay";
      axios
        .get(path)
        .then(response => {
          this.pendingForms = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },

    clickRow(item) {
      this.$router.push({ path: `/stays/${item.id}` });
    }
  }
};
</script>
